import enLang from './entries/en-US';
import viLang from './entries/vi-VN';

const AppLocale = {
  en: enLang,
  vi: viLang,
};

export default AppLocale;
